<template>
    <div>
      <div>
        <div class="overflow-x-scroll wrapper">
          <div class="table-wrapper">
            <table class="custom-table responsive-table border-collapse">
              <thead class="font-normal">
                <tr class="shadow-table rounded-lg opacity-50">
                  <th>TRANSACTION DATE</th>
                  <th>TRANSACTION CURRENCY</th>
                  <th>SUPPLIER</th>
                  <th>VAT TIN</th>
                  <th>ADDRESS</th>
                  <th>TRANSACTION ID</th>
                  <th>TOTAL VALUE</th>
                  <th>VAT EXCLUSIVE</th>
                  <th>VAT</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="rounded-lg bg-white"
                  v-for="i in [1, 2, 3, 4, 5, 6, 7]"
                  :key="i"
                >
                  <th>12/10/2020</th>
                  <th>NGN</th>
                  <th>Dangote Sugar</th>
                  <th>12kk23</th>
                  <th>124th Street, Surulere</th>
                  <th>TRX-1123</th>
                  <th>N1,234,000</th>
                  <th>N1,234,000</th>
                  <th>N1,234,000</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
  
      </div>
  
 
    </div>
  </template>
  
  <script>

  
  export default {
    props: ["bookings"],
    data() {
      return {
        showFilterModal: false,
        collectPaymentModal: false,
        selectedRowId: -1,
        shareLinkModal: false,
        totalCost: 0,
        transactionId: null,
        shippingId: "",
        paylink: "",
        email: "",
        payAmount: "",
      };
    },
    computed: {
      paymentParams() {
        return {
          paylink: this.paylink,
          email: this.email,
          payAmount: this.payAmount,
        };
      },
    },
    methods: {
      setNumDisplayCollection(val) {
        this.sortOptions = { ...this.sortOptions, pageSize: val };
      },
      setPageDisplayCollection(val) {
        this.sortOptions = { ...this.sortOptions, pageNumber: val };
      },
      sortItemProps(val) {
        this.sortOptions = { ...this.sortOptions, ...val };
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .actions {
    @apply w-auto absolute right-0 bg-white shadow-md z-10 py-3 px-2;
    min-width: 200px;
  }
  .actions div {
    @apply flex w-full py-2 px-2 items-center;
  }
  .icon {
    width: auto;
    padding-right: 5px;
  }
  th {
    font-weight: 300;
  }
  .table-wrapper {
    min-width: 1500px;
    width: 100%;
  }
  </style>
  